import { colors } from "../utils/const";

export const styles = {
  container: {
    alignSelf: "flex-start",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    bgcolor: colors.white,
    width: { xs: "300px", sm: "600px" },
    p: 3,
    borderRadius: 3,
    gap: 2,
    zIndex: 100,
  },
  inputWrapper: (theme) => ({ flex: "2 1 auto" }),
  label: (theme) => ({
    fontWeight: "bold",
    fontSize: "17px",
    color: colors.manhattan_blue,
    pb: 1,
    whiteSpace: "normal !important",
    overflow: "visible !important",
  }),
  input: {
    // "& MuiSelect-select": { height: "300px" },

    width: "100%",
    bgcolor: colors.white_smoke,
    borderRadius: 2,
    "& p": {
      bgcolor: "white",
      m: 0,
    },
    "& fieldset": {
      borderRadius: 2,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "grey",
      },
    },
  },
  helperText: (theme) => ({
    color: "#d32f2f",
    fontSize: "0.75rem",
    mx: 1,
    my: 0.2,
    minHeight: "18px",
  }),
  btn: {
    width: "100%",
    height: "45px",
    // mb: "40px",
    color: colors.white,
    border: `1px solid ${colors.yellow}`,
    backgroundColor: colors.yellow,
    borderRadius: 2,
    "&:disabled": {
      color: `${colors.grey} !important`,
      border: `1px solid ${colors.light_grey} !important`,
      backgroundColor: `${colors.light_grey} !important`,
    },
  },
  application_form: {
    alignSelf: "flex-start",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    bgcolor: colors.bg_grey,
    p: 3,
    borderRadius: 3,
    gap: 2,
    zIndex: 100,
  },
};
